import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/School.tsx
const SchoolIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M13.5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.7 2a.5.5 0 0 0-.5.5v4.175l-4.844 4.078a1 1 0 0 0-.211.247H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-3.145a1 1 0 0 0-.21-.247l-5-4.21a1.017 1.017 0 0 0-.046-.036V6h2.6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3.5Zm1 1.5v1h2v-1h-2ZM4 19v-6h2v6H4Zm12 0v-7.017l-4-3.368-4 3.368V19h8Zm2 0h2v-6h-2v6Z",
		fill: props.fill || "currentColor"
	})]
}));
//#endregion
export { SchoolIcon };
